import { Coordinates } from "./Coordinates";
import { StoreSearchType } from "../enums/StoreSearchType";
export class StoreSearchData extends Coordinates {
  constructor(coordinates, productData) {
    super(coordinates.getLatitude(), coordinates.getLongitude());
    if (productData === null || productData === void 0 ? void 0 : productData.productRef) {
      this.productRef = productData.productRef;
      const type = productData.type;
      this.storeSearchType = type === StoreSearchType.DELIVERY || type === StoreSearchType.STOCK ? type : undefined;
    }
  }
  getProductRef() {
    return this.productRef || '';
  }
  getStoreSearchType() {
    return this.storeSearchType;
  }
}